import {
	getAction
} from '@/api/index';
export default {
	data() {
		return {
			url: {
				listChannel: '/officialWebsite/c-api/channel/list'
			},
			channelList: []
		}
	},
	methods: {
		async loadData() {
			const res = await getAction(this.url.listChannel);
			console.log('======', res)
			if (res.success) {
				this.channelList = res.result;
			}
		}
	}
}